module.exports = __webpack_public_path__ + "static/src/nrl-teams/images/sharks.8c83104.png";


//////////////////
// WEBPACK FOOTER
// ./src/nrl-teams/images/sharks.png
// module id = p237
// module chunks = 0